import React from 'react'
import BEMHelper from 'react-bem-helper'

export const c = new BEMHelper('navbar')

export function Link({ href, onClick, className, children }) {
    return (
        <a {...c('link', '', className)} onClick={onClick} href={href}>
            {children}
        </a>
    )
}
